import { SEARCH_ALL_RETAILERS } from '../constants/searchAllRetailers';
import { CHECK_PERMISSIONS_LOADING } from '../constants/checkPermissionsTypes';

const initialState = {
  search: '',
};

const searchAllRetailers = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_ALL_RETAILERS:
      return {
        ...state,
        search: action.payload,
      };
    case CHECK_PERMISSIONS_LOADING:
      return { ...initialState };
    default:
      break;
  }

  return state;
};

export default searchAllRetailers;
